import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { windowForRouter } from "./components/phone/history";
import { App } from "./App";
import { AssetsHost } from "./assets/AssetsPicker";
import { AuthProvider } from "./auth/AuthContext";
import { ToastProvider } from "./components/ui/Toast";
import { currentWorkspaceSlug } from "./lib/workspace";
import { ThemeProvider } from "./theme/ThemeProvider";
import "./styles/suite.css";
import "./styles/index.css";
import "./styles/base.css";
import "./styles/kit.css";
import "./styles/assets.css";
import "./styles/auth.css";
import "./styles/phone.css";
import "./styles/phone-webinars.css";
import "./styles/season.css";
import "./styles/talk.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

// The workspace is the first path segment, so every route and link inside the
// operator app is written as if it were at the root. A tab keeps its workspace.
const workspace = currentWorkspaceSlug();

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter basename={workspace ? `/${workspace}` : undefined} window={windowForRouter()}>
            <App />
            <AssetsHost />
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
